import React, { useState, useEffect,useRef, useMemo } from 'react';
import JoditEditor, { Jodit, Dom }  from 'jodit-react';

import Api from '../../utils/Api'
import { saveAs } from "file-saver";
import moment from 'moment';
import { useParams } from 'react-router-dom';
import './Editor.scss'
import useAuthentication from '../../auth/useAuthentication';
import Slug from '../../utils/Slug';
import config from '../../config/config';
import axios from "axios";
import { nanoid } from 'nanoid'
import { toast } from 'react-toastify';

export default () => {

  // const editor = useRef(null);
  const { ContextMenu } = Jodit.modules;

	const [manual, setManual] = useState(null);
	// const [editorInstance, setEditorInstance] = useState(null);
	const [showBlocks, setShowBlocks] = useState(true);
  const context = useAuthentication();
  const { id } = useParams();

  // const [searchTerm, setSearchTerm] = useState('');
  // const [matches, setMatches] = useState([]);
  // const [editorContent, setEditorContent] = useState();
  const [toc, setToc] = useState(false);
  // const [currentIndex, setCurrentIndex] = useState(-1);

  // useEffect(() => {
  //   if (editor.current) {
  //     // Proper way to access the editor instance
  //     const editorInstance = editor.current.getInstance();
  //     if (editorInstance) {
  //       console.log('Editor initialized:', editorInstance);
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (context.user && context.user.token) {
      axios.defaults.headers.common['x-access-token'] = context.user?.token;
    }

  }, [context.user]);

  useEffect(() => {
    Api.apiGet('manuals/' + id).then(r => {
      if (r && r.data && r.data.text) {
        // r.data.text = r.data.text.replaceAll('custom-addendum-block', 'custom-addendum-block-hidden');
        // console.log(r.data);
        setManual(r.data);
      }
    }).catch(err => {
      console.log('Api error:', err);
    });
  }, [ id ]);

  const hasClass = (target, className) => {
    return new RegExp('(\\s|^)' + className + '(\\s|$)').test(target.className);
  };

  const getRootElement = (element) => {
    if (hasClass(element.parentNode, 'jodit-wysiwyg')) {
      return element;
    } else {
      return getRootElement(element.parentNode)
    }
  };

  const contentUpdated = content => {
    // const { html, headings } = assignHeadingIds(content);
    // editorInstance.value = html;
    // setToc(headings); // lista de TOC
  };

  useEffect(() => {
    if (manual) {
      if (!showBlocks) {
        const elems = document.getElementsByClassName('custom-addendum-block');
        Array.from(elems).forEach((el) => {
          const id = el.getElementsByClassName('custom-addendum-block-id')[0];
          if (id) {
            id.classList.remove('custom-addendum-block-id')
            id.classList.add('custom-addendum-block-id-hidden')
          }

          el.classList.remove('custom-addendum-block');
          el.classList.add('custom-addendum-block-hidden');
        });
      } else {
        const elems = document.getElementsByClassName('custom-addendum-block-hidden');
        Array.from(elems).forEach((el) => {
          const id = el.getElementsByClassName('custom-addendum-block-id-hidden')[0];
          if (id) {
            id.classList.remove('custom-addendum-block-id-hidden')
            id.classList.add('custom-addendum-block-id')
          }

          el.classList.add('custom-addendum-block');
          el.classList.remove('custom-addendum-block-hidden');
        });
      }
    }
  }, [showBlocks, manual]);



  const toolbarButtons = [ {
      // icon: 'angle-left',
      name: '< Back',
      tooltip: 'Back',
      exec(editor) {
        if (context.user && context.user.role && context.user.role == 'ADMIN') {
          if (window.confirm('Are you sure you want to go back? All unsaved changes will be lost.')) {
            window.location.href = '/app/manuals';
            return false;
          }
        } else {
          window.location.href = '/app/manuals';
          return false;
        }
      }
  } ];
  toolbarButtons.push('|');

  toolbarButtons.push({
    iconURL: 'https://www.svgrepo.com/show/453432/toc.svg',
    name: 'TOC',
    tooltip: 'Table of Contents',
    exec: (editor, b, btn) => {
      if (editor.toc) {
        console.log('a')
        setToc(false);
        editor.toc = false;
      } else {
        const { html, headings } = assignHeadingIds(editor.value);
        editor.value = html;
        setToc(headings); // lista de TOC
        editor.toc = true;
      }
    }
  });
  toolbarButtons.push('|');



  if (context.user && context.user.role && context.user.role == 'ADMIN') {

    // ...Jodit.defaultOptions.buttons,
    // toolbarButtons.push(..."left,center,right,justify,preview,bold,italic,underline,strikethrough,indent,outdent,eraser,copyformat,ul,ol,font,fontsize,paragraph,lineHeight,superscript,subscript,classSpan,image,source".split(','));
    // toolbarButtons.push(..."|,bold,italic,underline,strikethrough,|,left,center,right,justify,|,indent,outdent,|,eraser,copyformat,|,fontsize,lineHeight".split(','));
    toolbarButtons.push(..."|,undo,redo,|,bold,italic,underline,strikethrough,|,left,center,right,justify,|,indent,outdent,|,fontsize,lineHeight".split(','));

    toolbarButtons.push({
      name: 'customOrderedList',
      icon: 'ol',
      tooltip: 'Ordered List',
      list: {
        'lower-alpha': 'Lower Alpha (a, b, c)',
        'lower-roman': 'Lower Roman (i, ii, iii)',
        'decimal': 'Decimal (1, 2, 3)'
      },
      exec: (editor, current, control) => {
        let listType = 'lower-alpha';
        if (control && control.control && control.control.args && control.control.args[0]) {
          listType = control.control.args[0];
        }
        editor.execCommand('insertOrderedList');
        const sel = editor.selection.sel;
        if (sel && sel.rangeCount > 0) {
          let range = sel.getRangeAt(0);
          let selectedElement = range.commonAncestorContainer;

          let olElement = selectedElement.closest('ol');
          if (olElement) {
            olElement.style.listStyleType = listType;
          }
        }
      }
    });


    toolbarButtons.push({
      name: 'customFormattingList',
      icon: 'paragraph',
      tooltip: 'Define Formatting',
      list: {
        'my-h1': 'H1',
        'my-h2': 'H2',
        'my-h3': 'H3',
        'my-paragraph': 'Paragraph'
      },
      exec: (editor, current, control) => {
        let formattingType = 'my-paragraph';
        if (control && control.control && control.control.args && control.control.args[0]) {
          formattingType = control.control.args[0];
        }
        const sel = editor.selection.sel;
        if (sel && sel.rangeCount > 0) {
          if (formattingType == 'my-h1') {
            // editor.selection.commitStyle({ element: 'strong' }); // Wrap selected text in <h1> tag
            editor.selection.commitStyle({ element: 'h1' }); // Wrap selected text in <h1> tag
            let range = sel.getRangeAt(0);
            // let selectedContent = range.extractContents();
            // console.log(selectedContent)
            let selectedElement = range.commonAncestorContainer;

            // const strongElement = selectedElement.closest('strong');
            // strongElement.style.fontSize = '24px';
            const h1Element = selectedElement.closest('h1');
            const strong = document.createElement('strong');
            strong.style.fontSize = '24px';
              // and give it some content
            const newContent = document.createTextNode(selectedElement.textContent);
            // const newContent = document.createTextNode('');

            // add the text node to the newly created div
            strong.appendChild(newContent);


            selectedElement.appendChild(strong)
            h1Element.style.textAlign = 'center';
            // range.setStartAfter(range.startContainer);
            range.deleteContents();

            // h1Element.style.textTransform = 'capitalize';
            // h1Element.style.fontWeight = 'bold';
            // h1Element.style.fontSize = '24px';
            // h1Element.style.textDecoration = 'none';
            // h1Element.style.fontStyle = 'bold';
            // <h1 style="text-align: center;"><strong style="font-size: 24px;">Section 1. Ownership</strong></h1>

            // h1Element.appendChild(selectedContent);
          } else if (formattingType == 'my-h2') {
            // <div><strong><u>2-POSITION SCOPE</u></strong></div>
            editor.selection.commitStyle({ element: 'div' });
            let range = sel.getRangeAt(0);
            let selectedElement = range.commonAncestorContainer;
            const strong = document.createElement('strong');
            const u = document.createElement('u');
            const newContent = document.createTextNode(selectedElement.textContent);
            u.appendChild(newContent);
            strong.appendChild(u)
            selectedElement.appendChild(strong)
            range.deleteContents();
          } else if (formattingType == 'my-h3') {

            editor.selection.commitStyle({ element: 'div' });
            let range = sel.getRangeAt(0);
            let selectedElement = range.commonAncestorContainer;
            const strong = document.createElement('strong');
            const newContent = document.createTextNode(selectedElement.textContent);
            strong.appendChild(newContent)
            selectedElement.appendChild(strong)
            range.deleteContents();
          } else if (formattingType == 'my-paragraph') {
            // const h1Element = selectedElement.closest('p');
            const pElement = document.createElement('p');
            pElement.style.textAlign = 'left';
            pElement.style.fontSize = '20px';
            pElement.style.fontWeight = 'normal';
            pElement.style.textDecoration = 'none';
            pElement.style.fontStyle = 'italic';

            let range = sel.getRangeAt(0);

            // 3. Creamos el nuevo nodo con el texto seleccionado (por ejemplo, un <span> con estilo)
            let newNode = document.createElement("span");
            newNode.textContent = range.toString(); // Insertamos el texto seleccionado
            // newNode.style.backgroundColor = "yellow";  // Ejemplo de estilo (resaltado)

            // 4. Limpiamos la selección actual para evitar problemas de sobrescritura
            sel.removeAllRanges();

            // 5. Reemplazamos el rango seleccionado con el nuevo nodo
            range.deleteContents();   // Borramos el contenido seleccionado
            range.insertNode(newNode); // Insertamos el nuevo nodo

            // 6. Ajustamos el rango para que se sitúe después del nuevo nodo (opcional)
            range.setStartAfter(newNode);
            sel.addRange(range); // Seleccionamos el rango actualizado (opcional)
          }
        }

      }
    });


    toolbarButtons.push({
      name: 'highlight',
      icon: 'pencil',
      tooltip: 'Highlight Text',
      list: {
        'blue': 'Blue (AE Delegated)',
        'yellow': 'Yellow',
        'green': 'Green',
        'remove': 'Remove Highlight'
      },
      exec: (editor, current, control) => {
        const colorKey = control?.control?.args?.[0] || 'blue';
        const colors = { blue: '#bfdbfe', yellow: '#fbbf24', green: '#22c55e' };
        const textColors = { blue: '#1e3a5f', yellow: '#000000', green: '#ffffff' };

        if (colorKey === 'remove') {
          const sel = window.getSelection();
          if (!sel || sel.rangeCount === 0) return;
          let node = sel.getRangeAt(0).commonAncestorContainer;
          if (node.nodeType === 3) node = node.parentNode;
          while (node && !node.classList?.contains('ae-highlight')) node = node.parentNode;
          if (node?.classList?.contains('ae-highlight')) {
            const parent = node.parentNode;
            while (node.firstChild) parent.insertBefore(node.firstChild, node);
            parent.removeChild(node);
            editor.value = editor.editor.innerHTML;
          }
          return;
        }

        const sel = window.getSelection();
        if (!sel || sel.rangeCount === 0) return;
        const range = sel.getRangeAt(0);
        if (range.collapsed) return;

        const tempDiv = document.createElement('div');
        tempDiv.appendChild(range.cloneContents());
        const selectedHTML = tempDiv.innerHTML;
        if (!selectedHTML.trim()) return;

        range.deleteContents();
        const span = document.createElement('span');
        span.className = `ae-highlight ae-highlight-${colorKey}`;
        span.style.cssText = `background-color:${colors[colorKey]};color:${textColors[colorKey]};`;
        const frag = document.createRange().createContextualFragment(selectedHTML);
        span.appendChild(frag);
        range.insertNode(span);

        // Force Jodit to register the DOM change in its internal value
        editor.value = editor.editor.innerHTML;
      }
    });

    if (process.env.NODE_ENV == 'development' || (context.user && context.user.email && context.user.email == 'mradosta@pragmatia.com')) {
      toolbarButtons.push('|');
      toolbarButtons.push('source');
    }
    toolbarButtons.push('|');
    toolbarButtons.push('image');
    // toolbarButtons.push('search');

    toolbarButtons.push({
      iconURL: 'https://www.svgrepo.com/show/325174/eye-close.svg',
      name: 'Show Blocks',
      tooltip: 'Show Blocks',
      exec: (a, b, btn) => {
        setShowBlocks(!showBlocks);
      }
    });

    toolbarButtons.push({
      icon: 'eye',
      name: 'Hide Blocks',
      tooltip: 'Hide Blocks',
      exec: (editor, b, btn) => {
        setShowBlocks(!showBlocks);
      }
    });
    toolbarButtons.push('|');


    toolbarButtons.push({
      name: 'Save',
      tooltip: 'Save',
      exec(editor) {
        const currentText = editor.editor ? editor.editor.innerHTML : editor.value;
        Api.apiPost('manuals', { id, text: currentText }).then(r => {
          if (r && r.code) {
            toast.error(<div>Save failed: {r.message || r.code}</div>);
          } else {
            toast.success(<div>Manual saved!</div>);
          }
        }).catch(err => {
          toast.error(<div>Save failed. Please try again.</div>);
        });
        return false;
      }
    });
  }

  // toolbarButtons.push('|');

  toolbarButtons.push({
    name: 'Search',
    tooltip: 'Search',
    exec: (e, b, btn) => {
      e.execCommand('openSearchDialog');
    }
  });
  toolbarButtons.push('|');

  toolbarButtons.push({
    name: 'Download PDF',
    tooltip: 'Download PDF',
    exec(editor) {
      toast.success('Generating PDF, please wait...', {
        autoClose: 5000,
        hideProgressBar: false,
        progress: undefined,
        // theme: "light",
        // transition: Bounce,
        });
      setTimeout(() => {
        const outputName = 'DLTPolicy Manual-' + Slug.getSlug(manual.name, true) + '-' + moment().format('YYYY-MM-DD') + '.pdf';
        saveAs(
          config.API.BASE_URI + 'manuals/downloadPdf/' + id,
          outputName
        );
      }, 0);
      return false;
    }
  });



  const editorConfig = useMemo(() => ({
    events: {
      afterInit: (instance) => {
        // setEditorInstance(instance);
        if (context.user && context.user.role && context.user.role == 'ADMIN') {

          // document.body.classList.add('loading-indicator');

          const contextMenu = new ContextMenu(instance);
          instance.events.on(instance.editor, 'contextmenu', event => {

            const contextMenuOptions = [ ];

            if (manual.main) {
              contextMenuOptions.push(
                {
                  title: 'Add Page Break',
                  icon: 'valign',
                  exec: () => {
                    const rootElem = getRootElement(event.target);
                    const div = document.createElement('div');
                    div.innerHTML = 'PAGE-BREAK';
                    div.classList.add('pagebreak');
                    rootElem.parentNode.insertBefore(div, rootElem.nextSibling);
                    instance.synchronizeValues();
                    instance.setEditorValue();
                  }
                });
                contextMenuOptions.push({
                  title: 'Remove Page Break',
                  icon: 'bin',
                  exec: () => {
                    const pageBreakElem = event.target.closest('.pagebreak');
                    if (pageBreakElem) {
                      pageBreakElem.remove();
                      instance.synchronizeValues();
                      instance.setEditorValue();
                    } else {
                      alert('Right-click directly on a Page Break to remove it');
                    }
                  }
                });
                contextMenuOptions.push({
                  title: 'Add Block',
                  icon: 'plus',
                  exec: (e, i) => {
                    const sel = instance.selection.sel;
                    if (sel && sel.rangeCount > 0) {
                      let range = sel.getRangeAt(0);

                      if (hasClass(range.commonAncestorContainer, 'custom-addendum-block')) {
                        alert('You can\'t add a block inside an other block');
                        return;
                      }

                      let selectedContent = range.extractContents();

                      let newDiv = document.createElement('div');
                      newDiv.setAttribute('class', 'custom-addendum-block');

                      newDiv.appendChild(selectedContent);

                      const div = document.createElement('div');
                      div.className = 'custom-addendum-block-id';
                      div.innerHTML = nanoid();
                      newDiv.appendChild(div)


                      range.insertNode(newDiv);

                      range.setStartAfter(newDiv);
                      range.setEndAfter(newDiv);

                      sel.removeAllRanges();
                      sel.addRange(range);

                      const olElems = getRootElement(newDiv).getElementsByTagName('ol');
                      Array.from(olElems).forEach((olElem) => {
                        console.log(olElem);
                        const liElems = olElem.getElementsByTagName('li');
                        if (liElems.length <= 1) {
                          olElem.remove();
                        }
                      });

                      instance.synchronizeValues();
                      instance.setEditorValue();
                    }
                  }
                });
                contextMenuOptions.push({
                  title: 'Remove Block',
                  icon: 'bin',
                  exec: () => {
                    const rootElem = getRootElement(event.target);
                    rootElem.querySelectorAll('.custom-addendum-block').forEach(el => el.classList.remove('custom-addendum-block'));
                    rootElem.querySelectorAll('.custom-addendum-block-id').forEach(el => el.remove());
                  }
                });
            } else {
              contextMenuOptions.push({
                title: 'Add Addendum',
                icon: 'ok',
                exec: () => {

                  let rootElem = event.target;
                  let blockIdNode = rootElem.getElementsByClassName('custom-addendum-block-id');
                  if (blockIdNode.length == 0) {
                    rootElem = getRootElement(event.target);
                    blockIdNode = rootElem.getElementsByClassName('custom-addendum-block-id');
                  }
                  if (blockIdNode.length == 0) {
                    alert('Must define the block in the Main Policy Manual before adding an Addendum');
                    // instance.message.error('Hellow world!');
                  } else if (blockIdNode.length == 1) {
                    let alreadyHasAddendum = false;
                    const blockId = blockIdNode[0].innerText;

                    const elems = document.getElementsByClassName('addendum');
                    Array.from(elems).forEach((el) => {
                      if (blockId == el.getAttribute('data-block')) {
                        alreadyHasAddendum = true;
                      }
                    });

                    if (!alreadyHasAddendum) {
                      // let html = `<div data-block="${blockId}" class="addendum"><p>Enter an Addendum here...</p></div>`;
                      const date = moment().format('MMMM DD, YYYY HH:mm:ss');
                      // const date = new Date().toISOString().split('T')[0];
                      let html = `<div data-block="${blockId}" class="addendum">
                        <div style="width:100%;" class="addendum-meta-data">
                          <div class="addendum-to" style="float:left;text-align:left;color:#AD882F;font-size:15px;">Addendum to</div>
                          <div style="float:right;text-align:right;color:#B3B4B0;font-size:12px;">` + date + ` by <strong>${context.user.name}</strong></div>
                          <div style="clear:both;"></div>
                        </div>
                        <p>Enter an Addendum here...</p>
                      </div>`;

                      rootElem.insertAdjacentHTML('afterend', html);
                      instance.synchronizeValues();
                      instance.setEditorValue();
                    } else {
                      alert('The block has an Addendum. Edit it instead');
                    }
                  }
                }
              });
              contextMenuOptions.push({
                title: 'Remove Addendum',
                // icon: 'cancel',
                icon: 'bin',
                exec: () => {
                  const addendumElem = event.target.closest('.addendum');
                  if (addendumElem) {
                    if (window.confirm('Are you sure you want to delete the addendum?')) {
                      addendumElem.remove();
                      instance.synchronizeValues();
                      instance.setEditorValue();
                    }
                  } else {
                    alert('The block is not an Addendum');
                  }
                }
              });
              contextMenuOptions.push({
                title: 'Remove Page Break',
                icon: 'bin',
                exec: () => {
                  const pageBreakElem = event.target.closest('.pagebreak');
                  if (!pageBreakElem) {
                    alert('Right-click directly on a Page Break to remove it');
                    return;
                  }
                  pageBreakElem.remove();
                  instance.synchronizeValues();
                  // Strip addendums from a clone so we save clean main manual HTML
                  const clone = instance.editor.cloneNode(true);
                  clone.querySelectorAll('.addendum').forEach(el => el.remove());
                  Api.apiPost('manuals', { id: manual.mainManualId, text: clone.innerHTML }).then(r => {
                    if (r && r.code) {
                      toast.error('Failed to remove page break');
                    } else {
                      toast.success('Page break removed');
                    }
                  });
                }
              });
            }
            contextMenu.show(event.clientX, event.clientY, contextMenuOptions);
            return false; // prevent default context menu
          });
        }
      }
    },
    // readonly: (context.user && context.user.role && context.user.role == 'USER' ? true : false),
    activeButtonsInReadOnly: ['< Back', 'Search', 'TOC', 'Download PDF'],
    placeholder: '',
    defaultActionOnPaste: 'insert_as_html',
    defaultLineHeight: 1.5,
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
    enter: 'p',
    font: {
      list: {
        'Roboto Medium,Arial,sans-serif': 'Roboto'
      }
    },

    buttons: toolbarButtons,
    buttonsXS: toolbarButtons,
    buttonsMD: toolbarButtons,
    buttonsSM: toolbarButtons,
    removeButtons: showBlocks ? ['Show Blocks'] : ['Hide Blocks'],
    disablePlugins: [
      'powered-by-jodit',
      'classSpan'
    ],
    }), [ manual, showBlocks ],
  );



  const handleTOCClick = (e, id) => {
    e.preventDefault();
    const container = document.querySelector('.jodit-wysiwyg');
    const target = container.querySelector(`#${id}`);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };




  const assignHeadingIds = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const headings = doc.querySelectorAll('h1');

    headings.forEach((el, idx) => {
      if (!el.id) {
        el.id = `heading-${idx}`;
      }
    });

    // return [...headings].map(h => ({ id: h.id, text: h.textContent }));
    return {
      html: doc.body.innerHTML,
      headings: [...headings].map(h => ({ id: h.id, text: h.textContent }))
    };
  };


	return (
    <div className='flex flex-row mx-auto h-screen'>

      { manual && <div className='flex flex-col w-[20%] overflow-hidden'>
        {toc && <>
          <div className='font-bold text-lg mt-5'>Table of Contents</div>
          <ul className='bg-[#F9F9F9] me-3'>
            { toc.map((item) => (
              <li key={item.id} className='py-2 ps-3 hover:bg-[#F1F1F1] hover:border-e-[5px] border-[#113D60]'>
                <a href={`#${item.id}`} onClick={(e) => handleTOCClick(e, item.id)}>
                  {item.text}
                </a>
              </li>
            )) }
          </ul>
        </>}
      </div> }

      {/* <div className={`${toc ? 'lg:w-[80%]' : 'lg:w-[1000px]'} overflow-y-auto h-full mx-auto`}> */}
      <div className={`lg:w-[80%] overflow-y-auto h-full mx-auto`}>
        { manual && <div className='lg:w-[1000px] mx-auto text-center p-2 text-xl font-bold'>{ manual.name }</div> }

        { manual && <JoditEditor
          // ref={editor}
          value={manual.text}
          config={editorConfig}
          tabIndex={1} // tabIndex of textarea
          // onBlur={newContent => contentUpdated(newContent)} // preferred to use only this option to update the content for performance reasons
          // onChange={newContent => {setContent(newContent)}}
        /> }
      </div>
    </div>
	);
};